import React, {Component} from 'react';
import YouTube from 'react-youtube';
import {Button} from 'react-bootstrap';
import {isMobile} from 'react-device-detect';

export default class DataCard extends Component {

/*
  ytid or img (optional)
  title
  tagline
  description
  button1Text
  button2Text
  button1Link
  button2Link
  right
*/

  GetVisualComponent() {
    const opts = {
      height: isMobile ? window.height * .75 : 330,
      width: isMobile ? window.width : 550,
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0
      }
    };
    const className = isMobile ? "projectImageMobile" : "projectImageBrowser";
    if (this.props.ytid) {
      return (
        <div className={className}>
          <YouTube
            videoId={this.props.ytid}
            opts={opts}/>
        </div>
      );
    } else if (this.props.img) {
      return (
        <div className={className}>
          <img className={className} alt="" src={this.props.img}/>
        </div>
      );
    } else {
      return null;
    }
  }

  renderButtonOne() {
    return (
      this.props.button1Text ? (
        <div className="pcButton">
          <Button type="secondary" href={this.props.button1Link}>
            <p style={{'text-align': 'center', 'margin-bottom': '0px'}}>
              {this.props.button1Text}
            </p>
          </Button>
        </div>) : <div/>
    );
  }

  renderButtonTwo() {
    return (
      this.props.button2Text ? (<div className="pcButton">
        <Button type="secondary" href={this.props.button2Link}>
          <p style={{'text-align': 'center', 'margin-bottom': '0px'}}>
            {this.props.button2Text}
          </p>
        </Button>
      </div>) : <div/>
    );
  }

  getButtons() {
    return (
      <div className="pcButtons">
        {this.renderButtonOne()}
        {this.renderButtonTwo()}
      </div>
    );
  }

  hasImage() {
    return this.props.ytid != null || this.props.img != null;
  }

  render() {
    const className = isMobile ? "projectTextMobile" : "projectTextBrowser";
    if (this.props.right && !isMobile) {
      return (
        <div className="projectCard">
          {this.GetVisualComponent()}
          <div className={className} style={{"width": !this.hasImage() ? "100%" : null}}>
            <h2>{this.props.title}</h2>
            <br/>
            <h3>{this.props.tagline}</h3>
            <br/>
            <p className="contentText">{this.props.description}</p>
          </div>
          {this.getButtons()}
        </div>
      )
    }
    return (
      <div className="projectCard">
        <div className={className} style={{"width": !this.hasImage() ? "100%" : null}}>
          <h2>{this.props.title}</h2>
          <br/>
          <h3>{this.props.tagline}</h3>
          <br/>
          <p className="contentText">{this.props.description}</p>
        </div>
        {this.GetVisualComponent()}
        {this.getButtons()}
      </div>
    );
  }
}
